export default __webpack_public_path__ + "static/professional-training-journey-begins-dc103ccd571165711431810a6bd02523.png";